import { Url } from '../../utils/codecUtils';
import { AutomationDatapoint } from '../models/automation';
import { AutomationResponseAutomationBlocker } from '../models/automationResponseAutomationBlocker';
import {
  automationPayloadSchema,
  automationResponseSchema,
} from './automation.schema';

export type AutomationPayload = {
  beginDate: string;
  endDate: string;
};

export type AutomationResponse = {
  beginDate: string;
  endDate: string;
  queue: Url;
  automationBlockers: AutomationResponseAutomationBlocker[];
  datapoints: AutomationDatapoint[];
  totals: {
    documentCount: number;
    automation: number;
  };
};

export const automation = (queueId: number, payload: AutomationPayload) => {
  return {
    endpoint: `/queues/${queueId}/automation`,
    method: 'POST',
    payloadSchema: automationPayloadSchema,
    payload,
    responseSchema: automationResponseSchema,
  } as const;
};
